import { render, staticRenderFns } from "./downLoadAlter.vue?vue&type=template&id=39e540be&scoped=true"
import script from "./downLoadAlter.vue?vue&type=script&lang=js"
export * from "./downLoadAlter.vue?vue&type=script&lang=js"
import style0 from "./downLoadAlter.vue?vue&type=style&index=0&id=39e540be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e540be",
  null
  
)

export default component.exports